import styled, { css } from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const textLinkBase = css`
  ${props => props.theme.fontStackBody};
  text-decoration: underline;
  color: ${props => props.theme.blue};
  transition: color ease 0.25s;
  cursor: pointer;
  svg {
    transition: fill ease 0.25s;
    fill: ${props => props.theme.blue};
  }
  &:hover {
    color: ${props => props.theme.toreaBay};
    svg {
      fill: ${props => props.theme.toreaBay};
    }
  }
  &:hover {
    text-decoration: underline;
  }
`;

export const TextLink = styled.a`
  ${textLinkBase}
`;
export const TextReactLink = styled(Link)`
  ${textLinkBase}
  ${props =>
    (props.styled || {}).underline ||
    css`
      text-decoration: none;
    `}
    ${props =>
      props.bold &&
      css`
        font-weight: 700;
      `}
      ${props =>
        props.underline &&
        css`
          text-decoration: underline;
        `}
`;

const greyTextLinkBase = css`
  ${props => props.theme.fontStackBody};
  text-decoration: underline;
  color: ${props => props.theme.dustierGray};
  transition: color ease 0.25s;
  cursor: pointer;
  &:hover {
    color: black;
  }
`;
export const GreyTextLink = styled.a`
  ${greyTextLinkBase}
`;

export const GreyTextReactLink = styled(Link)`
  ${greyTextLinkBase}
`;

const linkBase = css`
  ${props => props.theme.fontStackHeader};
  line-height: 17px;
  font-size: 13px;
  text-transform: uppercase;
  font-weight: ${props => ((props.styled || {}).bold ? 600 : 400)};
  transition: color ease 0.25s;
  cursor: pointer;
  ${props =>
    (props.styled || {}).underline &&
    css`
      text-decoration: underline;
    `}
  svg {
    margin-left: 3px;
    margin-bottom: 1px;
    height: 7px;
    transition: fill ease 0.25s;
  }
`;

const greyLinkBase = css`
  ${linkBase};
  color: ${props => props.theme.dustierGray};
  svg {
    fill: ${props => props.theme.dustierGray};
  }
  &:hover {
    color: ${props => props.theme.dustyGray};
    svg {
      fill: ${props => props.theme.dustyGray};
    }
  }
`;

export const GreyLink = styled.a`
  ${greyLinkBase}
`;

export const GreyStyledLink = styled(Link)`
  ${greyLinkBase}
  ${props =>
    props.bold &&
    css`
      font-weight: 600;
    `}
`;

export const blueLinkBase = css`
  ${linkBase};
  color: ${props => props.theme.blue};
  svg {
    fill: ${props => props.theme.blue};
  }
  &:hover {
    color: ${props => props.theme.toreaBay};
    svg {
      fill: ${props => props.theme.toreaBay};
    }
  }
  ${props =>
    props.bold &&
    css`
      font-weight: 600;
    `}
`;

export const BlueLink = styled.a`
  ${blueLinkBase};
`;

export const BlueStyledLink = styled(Link)`
  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}

  ${blueLinkBase};
`;

const blueTextLinkBase = css`
  ${textLinkBase}
  font-size: 1.2rem;
  font-weight: 300;
`;

export const BlueTextLink = styled(Link)`
  ${blueTextLinkBase}
  padding: 2px 8px;
`;

export const BlueTextLinkButton = styled.button`
  ${blueTextLinkBase}
  padding: 2px 8px;
`;

export const BlueTextLinkNormalized = styled(Link)`
  ${blueTextLinkBase}
`;

const actionLinkBase = css`
  ${props => props.theme.fontStackBody};
  font-size: 1.2rem;
  font-weight: 300;
  padding: 2px 4px;
  cursor: pointer;
  color: black;
  @media screen and (max-width: 374px) {
    text-align: center;
  }
`;

export const ActionLink = styled(Link)`
  ${actionLinkBase}
`;

export const ActionLinkButton = styled.button`
  ${actionLinkBase}
`;

export const LinkIconDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  ${BlueStyledLink} {
    font-weight: 600;
    margin-right: 5px;
  }
  &:hover {
    svg {
      fill: ${props => props.theme.toreaBay};
    }
  }
`;

export const brandedLinkBase = css`
  ${linkBase};
  color: ${props => props.theme.brand};
  svg {
    fill: ${props => props.theme.brand};
  }
  &:hover {
    ${props =>
      props.isWhiteLabel &&
      css`
        opacity: 0.8;
      `}
    color: ${props => props.theme.indigo};
    svg {
      fill: ${props => props.theme.indigo};
    }
  }
  ${props =>
    props.bold &&
    css`
      font-weight: 600;
    `}
`;

export const BrandedLink = styled.a`
  ${brandedLinkBase};
`;
